import { CdkScrollable } from '@angular/cdk/scrolling';
import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ZvBlockUi } from '@zvoove/components/block-ui';
import { ZvButton } from '@zvoove/components/button';
import { ZvErrorMessagePipe } from '@zvoove/components/core';
import { Subscription } from 'rxjs';
const _c0 = ["*"];
function ZvDialogWrapper_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dialogTitle, " ");
  }
}
function ZvDialogWrapper_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "zv-block-ui", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("blocked", ctx_r0.contentBlocked);
  }
}
function ZvDialogWrapper_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-progress-bar", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.progress);
  }
}
function ZvDialogWrapper_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.progress, "%");
  }
}
function ZvDialogWrapper_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "zvErrorMessage");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.exception.errorObject), " ");
  }
}
function ZvDialogWrapper_For_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "zv-button", 9);
    i0.ɵɵlistener("click", function ZvDialogWrapper_For_10_Template_zv_button_click_0_listener() {
      const btn_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      return i0.ɵɵresetView(btn_r3.click());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_13_0;
    const btn_r3 = ctx.$implicit;
    i0.ɵɵproperty("type", btn_r3.type)("color", btn_r3.color)("icon", btn_r3.icon)("disabled", (tmp_13_0 = btn_r3.disabled && btn_r3.disabled()) !== null && tmp_13_0 !== undefined ? tmp_13_0 : false)("dataCy", btn_r3.dataCy);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", btn_r3.label, " ");
  }
}
let ZvDialogWrapper = /*#__PURE__*/(() => {
  class ZvDialogWrapper {
    cd;
    get dialogTitle() {
      return this.dataSource.dialogTitle;
    }
    get buttons() {
      return this.dataSource.buttons;
    }
    get contentVisible() {
      return this.dataSource.contentVisible;
    }
    get contentBlocked() {
      return this.dataSource.contentBlocked;
    }
    get exception() {
      return this.dataSource.exception;
    }
    get progress() {
      return this.dataSource.progress;
    }
    get showProgress() {
      return this.progress != null && this.progress >= 0;
    }
    set dataSource(value) {
      if (this._dataSource) {
        this._dataSource.disconnect();
        this._dataSourceSubscription.unsubscribe();
      }
      this._dataSource = value;
      if (this._dataSource) {
        this._dataSourceSubscription = this._dataSource.connect().subscribe(() => {
          this.cd.markForCheck();
        });
      }
    }
    get dataSource() {
      return this._dataSource;
    }
    _dataSource;
    _dataSourceSubscription = Subscription.EMPTY;
    constructor(cd) {
      this.cd = cd;
    }
    ngOnDestroy() {
      this._dataSourceSubscription.unsubscribe();
      if (this._dataSource) {
        this._dataSource.disconnect();
      }
    }
    static ɵfac = function ZvDialogWrapper_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvDialogWrapper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvDialogWrapper,
      selectors: [["zv-dialog-wrapper"]],
      inputs: {
        dataSource: "dataSource"
      },
      ngContentSelectors: _c0,
      decls: 11,
      vars: 5,
      consts: [["mat-dialog-title", ""], [3, "blocked"], [1, "zv-dialog-wrapper__action-bar-container"], [1, "zv-dialog-wrapper__progress-container"], ["mode", "determinate", 1, "zv-dialog-wrapper__progres-bar", 3, "value"], [1, "zv-dialog-wrapper__progress-text"], [1, "zv-dialog-wrapper__error"], [1, "zv-dialog-wrapper__buttons"], [3, "type", "color", "icon", "disabled", "dataCy"], [3, "click", "type", "color", "icon", "disabled", "dataCy"]],
      template: function ZvDialogWrapper_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, ZvDialogWrapper_Conditional_0_Template, 2, 1, "h1", 0);
          i0.ɵɵelementStart(1, "mat-dialog-content");
          i0.ɵɵtemplate(2, ZvDialogWrapper_Conditional_2_Template, 2, 1, "zv-block-ui", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "mat-dialog-actions", 2)(4, "div", 3);
          i0.ɵɵtemplate(5, ZvDialogWrapper_Conditional_5_Template, 1, 1, "mat-progress-bar", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, ZvDialogWrapper_Conditional_6_Template, 2, 1, "div", 5)(7, ZvDialogWrapper_Conditional_7_Template, 3, 3, "div", 6);
          i0.ɵɵelementStart(8, "div", 7);
          i0.ɵɵrepeaterCreate(9, ZvDialogWrapper_For_10_Template, 2, 6, "zv-button", 8, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.dialogTitle ? 0 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.contentVisible ? 2 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.showProgress ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showProgress ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.exception ? 7 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx.buttons);
        }
      },
      dependencies: [MatDialogTitle, MatDialogContent, ZvBlockUi, MatDialogActions, MatProgressBar, ZvButton, ZvErrorMessagePipe],
      styles: [".zv-dialog-wrapper__error{color:var(--zv-components-error)}.zv-dialog-wrapper__buttons{margin-left:auto;display:flex;gap:8px}.zv-dialog-wrapper__action-button{margin:.25em}zv-dialog-wrapper{display:block;max-width:calc(80vw - 48px)}.zv-dialog-wrapper__progress-container{position:absolute;top:0;left:0;right:0;overflow:hidden;min-height:4px}.zv-dialog-wrapper__progress-text{align-self:center}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvDialogWrapper;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @deprecated ZvDialogWrapper component is standalone now */
let ZvDialogWrapperModule = /*#__PURE__*/(() => {
  class ZvDialogWrapperModule {
    static ɵfac = function ZvDialogWrapperModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvDialogWrapperModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ZvDialogWrapperModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ZvDialogWrapper]
    });
  }
  return ZvDialogWrapperModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// export what ./public_api exports so we can import with the lib name like this:
// import { ModuleA } from 'libname'

/**
 * Generated bundle index. Do not edit.
 */

export { ZvDialogWrapper, ZvDialogWrapperModule };
